import {IMetaTag} from '@core/api/data-access';

import {signalStoreDefinition} from '../';

export const MetaTagsStore = signalStoreDefinition(
	{
		metaTags: null as IMetaTag[],
		loaded: false,
		loading: false,
		lastUpdated: 0,
	},
	{
		clearOn: 'logout',
	},
);

export default MetaTagsStore;
